module.exports = __webpack_public_path__ + "img/sssProject.1e8948ff.jpeg";